import { HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SupportTicketApiModel } from "src/app/models/api/support/supportTicketApiModel";
import { LoggerService } from "../../infra/logger/logger.service";
import { HttpService } from "../http/http.service";

@Injectable({
    providedIn: "root",
})
export class SupportHttpService {
    private readonly _baseUrl: string = "support";
    private readonly _ticketsBaseUrl = this._baseUrl + "/tickets";
    private readonly _uploadsBaseUrl = this._baseUrl + "/uploads";

    constructor(
        private _httpService: HttpService,
        private _logger: LoggerService,
    ) {}

    /**
     * Create a new support ticket
     */
    public createSupportTicket(newSupportTicketModel: SupportTicketApiModel): Observable<string> {
        const url = `${this._ticketsBaseUrl}`;

        return this._httpService.post<object, string>(url, newSupportTicketModel);
    }

    /**
     * Upload files to support
     */
    public uploadFiles(newSupportTicketModel: FormData): Observable<string> {
        const url = `${this._uploadsBaseUrl}`;

        return this._httpService.post<object, string>(url, newSupportTicketModel, new HttpHeaders({ "Content-Type": "multipart/form-data" }));
    }
}
